export const defaultSettings = {
  env: import.meta.env.VITE_ENV || 'localhost',
  version: '1.0',
  commitId: import.meta.env.VITE_COMMIT_ID || '',
  host: '',
  sentry: {
    enabled: false,
  },
  amplify: {
    region: '',
    userPoolId: '',
    userPoolWebClientId: '',
  },
  versionCheck: {
    enabled: true,
  },
};
